import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "@fontsource/public-sans/400.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/600.css";
import "@fontsource/public-sans/700.css";
import "@/tailwind.css";
import "@/App.less";
import { router } from "@/app/router";
import { environment } from "@/shared/config/environment";
import legacyStore from "@/legacy/store";

legacyStore.commit("setBaseUrl", environment.serviceBaseUrl);

const container = document.getElementById("app");
if (!container) throw new Error("Elemento #app non trovato");
createRoot(container).render(<RouterProvider router={router} />);
